import { render, staticRenderFns } from "./attachmentDialog.vue?vue&type=template&id=0e73c85e&scoped=true"
import script from "./attachmentDialog.vue?vue&type=script&lang=js"
export * from "./attachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e73c85e",
  null
  
)

export default component.exports